module.exports = __webpack_public_path__ + "static/media/gg.725e4224.png";